import { render, staticRenderFns } from "./ProjectMediacontactPartnerFeatureForm.vue?vue&type=template&id=24ba7902"
import script from "./ProjectMediacontactPartnerFeatureForm.vue?vue&type=script&lang=js"
export * from "./ProjectMediacontactPartnerFeatureForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports